var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.consultandoElBack } },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("h5", { staticClass: "text-center" }, [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.actividadesRetribucion.modalBusquedaBecarios.titulo"
                        )
                      ),
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  !!_vm.clavePrograma
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-for": "filtro-clave-programa",
                            label: _vm.$t(
                              "apeironGwApp.buscadorBecarios.campos.clavePrograma"
                            ),
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "filtro-clave-programa",
                              disabled: "",
                            },
                            model: {
                              value: _vm.clavePrograma,
                              callback: function ($$v) {
                                _vm.clavePrograma = $$v
                              },
                              expression: "clavePrograma",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "filtro-cvus-becarios",
                        label: _vm.$t(
                          "apeironGwApp.buscadorBecarios.campos.filtroCvu"
                        ),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { name: "filtro-cvus-becarios" },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroCvuBecario,
                          callback: function ($$v) {
                            _vm.filtroCvuBecario = $$v
                          },
                          expression: "filtroCvuBecario",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12", md: "6" } }),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-4",
                      attrs: { variant: "primary" },
                      on: { click: _vm.consultarBecas },
                    },
                    [
                      _c("b-icon-search"),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.buscadorBecarios.acciones.buscar"
                            )
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.respuestaBeca?.beca
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: _vm.$t(
                                      "apeironGwApp.buscadorBecarios.campos.cvu"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.respuestaBeca?.beca?.becario?.cvu
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: _vm.$t(
                                      "apeironGwApp.buscadorBecarios.campos.numeroApoyo"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.respuestaBeca?.beca?.numeroApoyo
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: _vm.$t(
                                      "apeironGwApp.persona.nombre"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.respuestaBeca?.beca?.becario
                                          ?.nombre +
                                          " " +
                                          _vm.respuestaBeca?.beca?.becario
                                            ?.apellidoPaterno +
                                          " " +
                                          _vm.respuestaBeca?.beca?.becario
                                            ?.apellidoMaterno
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: _vm.$t(
                                      "apeironGwApp.buscadorBecarios.campos.duracionBeca"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.respuestaBeca?.beca?.periodoBeca
                                          ?.duracionBeca
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: _vm.$t(
                                      "apeironGwApp.buscadorBecarios.campos.fechaInicioBeca"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.respuestaBeca?.beca?.periodoBeca
                                          ?.fechaInicioBeca
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    label: _vm.$t(
                                      "apeironGwApp.buscadorBecarios.campos.fechaFinBeca"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.respuestaBeca?.beca?.periodoBeca
                                          ?.fechaFinBeca
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.esReadOnly
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "mt-2 text-right" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.emitirSeleccion()
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon-plus-circle"),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.buscadorBecarios.acciones.agregarBecario"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }